import { useCallback } from "react";

import { viewModelToInput } from "./converter/view-model-to-input";
import { useSiteControllerSettingTlLincolnMutation } from "../../repository/mutation/use-case";

import type { SiteControllerSettingTllFormModel } from "../../type";

type Props = {
	viewModel: SiteControllerSettingTllFormModel["ViewModel"]; //
};

export const useSiteControllerSettingTlLincoln = ({ viewModel }: Props) => {
	const { onUpdate: _onUpdate } = useSiteControllerSettingTlLincolnMutation();
	const onUpdate = useCallback(async () => {
		const input = viewModelToInput({ viewModel });
		return await _onUpdate({ input });
	}, [_onUpdate, viewModel]);

	return { onUpdate };
};
